export default {
  __html: `<g fill="none" fill-rule="evenodd">
                <path fill="#fff" fill-rule="nonzero" d="M47.8 51.4c-.8 0-1.6-.3-2.2-.9L1.1 6.1C-.1 4.9-.1 3 1.1 1.8 2.3.6 4.2.6 5.4 1.8l44.5 44.4c1.2 1.2 1.2 3.1 0 4.3-.5.6-1.3.9-2.1.9zM3.3 52.1c-.8 0-1.6-.3-2.2-.9-1.2-1.2-1.2-3.1 0-4.3l14.5-14.3c1.2-1.2 3.1-1.2 4.3 0 1.2 1.2 1.2 3.1 0 4.3L5.4 51.2c-.6.6-1.3.9-2.1.9zM34 21.3c-.8 0-1.6-.3-2.2-.9-1.2-1.2-1.2-3.1 0-4.3L46.2 1.9c1.2-1.2 3.1-1.2 4.3 0 1.2 1.2 1.2 3.1 0 4.3L36.1 20.4c-.6.6-1.4.9-2.1.9z"/>
                <path d="M-25.2-24.6H76.9V77.5H-25.2z"/>
            </g>`
}
